import { withAsync } from '@helpcenter/with-async';
import { lazyForPaint } from 'react-loosely-lazy';

export const CsmFolderForHubs = withAsync({
	loader: lazyForPaint(() => import(/* webpackChunkName: "csm-hub-folder" */ './csm-hub-variants')),
});
